/**********************************************************
Footer Modal
**********************************************************/
import React from 'react';
const $ = window.$;

const FooterModal = (WrappedComponent) => (props) => {
  const { id, onClick, footer, view } = props;

  $(document).ready(function(){
    $(`#${id}`).modal();
  });
  return (
    <div>
      <div id={`${id}`} className="modal bottom-sheet modal-fixed-footer modal-app-display">
        <div className="modal-content">
          <div>
            <WrappedComponent {...props} />
          </div>
        </div>
        {
          footer ?
            <div className="modal-footer">
              { view ? '' : <a href="#!" className="modal-action modal-close waves-effect waves-green btn-flat" onClick={onClick}>Submit</a> }
              <a href="#!" className="modal-action modal-close waves-effect btn-flat">Close</a>
            </div>
          : ''
        }
      </div>
    </div>
  );
}

export default FooterModal;



/* END */



// WEBPACK FOOTER //
// ./src/irrigation/components/footer_modal.js